import { h } from '../utils/dom.js';

export const SkeletonText = (width = '100%') =>
  h('div', { class: 'skeleton skeleton-text', style: { width } });

export const SkeletonRow = (cols) =>
  h('tr', {},
    ...Array.from({ length: cols }, () =>
      h('td', {}, SkeletonText()),
    ),
  );

export const SkeletonTable = (rows = 5, cols = 5) =>
  h('tbody', { class: 'skeleton-tbody' },
    ...Array.from({ length: rows }, () => SkeletonRow(cols)),
  );
